/**
 * OneTrust Consent Helper
 *
 * OneTrust Cookie Categories:
 * - C0001: Strictly Necessary
 * - C0002: Performance/Analytics
 * - C0003: Functional
 * - C0004: Targeting/Advertising
 */

import clientSide from "./clientSide";
declare global {
  interface Window {
    OnetrustActiveGroups?: string;
  }
}

/**
 * Check if user has granted consent for a specific OneTrust category
 * @param group - The OneTrust group ID (e.g., 'C0002', 'C0004')
 * @returns boolean - true if consent is granted, false otherwise
 */
export const hasConsent = (group: string): boolean => {
  if (!clientSide) return false;
  const activeGroups = window.OnetrustActiveGroups || "";
  return activeGroups.includes(group);
};
export const hasPerformanceConsent = (): boolean => hasConsent("C0002");
export const hasFunctionalConsent = (): boolean => hasConsent("C0003");
export const hasTargetingConsent = (): boolean => hasConsent("C0004");